import { AsyncThunkConfigWithRejectValue, createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { postQuickCreateCatalog } from '@/redux/modules/quickCreate/catalog/quickCreateCatalog.api';
import {
    QuickCreateCatalog,
    QuickCreateCatalogSuccessPayload,
} from '@/redux/modules/quickCreate/catalog/quickCreateCatalog.types';

export const addQuickCreateCatalog = createAsyncThunk<
    QuickCreateCatalogSuccessPayload,
    QuickCreateCatalog,
    AsyncThunkConfigWithRejectValue
>('la/ui/quickCreateCatalog/addQuickCreateCatalog', async (catalog, { getState, rejectWithValue }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);

    try {
        const { payload } = await postQuickCreateCatalog({
            authToken,
            catalog,
            deployment,
        });

        if (typeof payload === 'string') {
            throw payload;
        }
        return payload;
    } catch (error) {
        return rejectWithValue(new Error(error));
    }
});
